import React from 'react';

import styles from './styles';

const SimpleLoading = () => {
    const classes = styles();
    return (
        <div className={classes.container}>
            <div className="lds-ellipsis">
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    );
};

export default SimpleLoading;
